module.exports = __webpack_public_path__ + "static/media/linkedInIcon.a4459e56.svg";